import React from 'react'
import { ReportAppDashboardWidgetType as type } from '@/enums/ReportAppDashboardWidgetType'
import {
  NotificationsWidget,
  MessagesWidget,
  ReportSubmissionsWidget
} from '@/components/dashboard/widgets'

const widgetComponents = []
widgetComponents[type.Notifications] = {
  outerProps: { className: 'col-md-6 col-lg-4 col-xl-3' },
  component: (item, props) => <NotificationsWidget widgetItem={item} {...props} />
}
widgetComponents[type.SubmittedReportGroups] = {
  outerProps: { className: 'col-md-6 col-lg-4 col-xl-5' },
  component: (item, props) => <ReportSubmissionsWidget widgetItem={item} {...props} />
}
widgetComponents[type.Messages] = {
  outerProps: { className: 'col-md-12 col-lg-12 col-xl-12' },
  component: (item, props) => <MessagesWidget widgetItem={item} {...props} />
}

export default widgetComponents



// WEBPACK FOOTER //
// ./src/report-app/widgets.js